export const NOT_AVAILABLE_BECAUSE_TARIFF = 'На вашем тарифе этот раздел недоступен';
export const NOT_AVAILABLE_BECAUSE_TARIFF_DATE = 'На вашем тарифе выбор дат недоступен';
export const NOT_AVAILABLE_TRIAL =
  'Тестовый тарифный план предоставляет доступ к данным только за прошлую неделю';
